import React from "react";
import "./MindBlockBanner.css";

const MindBlockBanner = () => {
  return (
    <div className="mind-block-banner">
      <h1>Book Our Mind-Blowing Services</h1>
      <hr />
      <button>BOOK NOW</button>
    </div>
  );
};

export default MindBlockBanner;
